import axios from "axios"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}) {
  if (!options.headers) {
    options.headers = {}
  }
  options.headers.Authorization = localStorage.getItem("token")
  return options
}

export default {
  fetchTACTesting(payload) {
    // Direkter Aufruf auf das Live-Backend
    const url = "https://app.wellcomefit.ch/api/tactesting"
    return axios.post(url, payload, buildOptions()).then((res) => res.data)
  },
  planning: {
    fetchActuals(params = {}) {
      const url = buildUrl("plans/actuals")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
    fetchPlans(params = {}) {
      const url = buildUrl("plans")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
    savePlan(data) {
      const url = buildUrl("plans")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    uploadRevenueCsv(data) {
      const url = buildUrl("plans/upload-revenue-csv")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
  },
}
